import { IOfferDescription } from "./IOfferDescription";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 22.04.13
 * Time: 11:43
 */

import { Constants_Offer } from "../Constants_Offer";
import { OfferDescriptionDictionary } from "../OfferDescriptionDictionary";

/**
 * Defines cost in empire resources for offer acception
 */
export class OfferDescriptionCostResources implements IOfferDescription {
    private _wood: number = 0;
    private _stone: number = 0;
    private _food: number = 0;
    private _coal: number = 0;
    private _oil: number = 0;
    private _glass: number = 0;

    public get name(): string {
        return Constants_Offer.OFFER_COST_EMPIRE_RESOURCES;
    }

    public registerOfferDescription(dictonary: OfferDescriptionDictionary): void {
        dictonary.addEntry(this.name, this);
    }

    public parseFromObjectParam(params: any): void {
        this._wood = params.shift();
        this._stone = params.shift();
        this._food = params.shift();
        this._coal = params.shift();
        this._oil = params.shift();
        this._glass = params.shift();
    }

    public get wood(): number {
        return this._wood;
    }

    public get stone(): number {
        return this._stone;
    }

    public get food(): number {
        return this._food;
    }

    public get coal(): number {
        return this._coal;
    }

    public get oil(): number {
        return this._oil;
    }

    public get glass(): number {
        return this._glass;
    }

    public dispose(): void {
    }
}

